'use strict';

/**
 * @private
 * @function
 * @description Binds event to the place holder (.blur)
 */
function initializeEvents() {
	if($(window).width() <= 1024 && $('.header-search .simplesearch').find('form').find('input#q').length > 0){
		//$('.header-search .simplesearch').find('form').find('input#q').attr('placeholder' ,$('input.searchplaceholder').val());
	}
    $('#q').focus(function () {
        var input = $(this);
        if (input.val() === input.attr('placeholder')) {
            input.val('');
        }
    });
}

exports.init = initializeEvents;
